import styled from 'styled-components';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { MAX_WIDTH } from './constants';
export var ValueContainer = styled(motion.div).withConfig({
  displayName: "Valuestyles__ValueContainer",
  componentId: "keen-query-creator__sc-gt1bsp-0"
})(["&&&{padding:10px 14px;height:37px;box-sizing:border-box;max-width:", "px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;color:", ";}"], MAX_WIDTH, colors.blue[500]);
export var MotionPropertyItem = styled(motion.div).withConfig({
  displayName: "Valuestyles__MotionPropertyItem",
  componentId: "keen-query-creator__sc-gt1bsp-1"
})(["&&&{border-left:solid 1px ", ";}"], colors.white[500]);